import 'COMMON';
import { eksmoBP } from 'Lib/bp/bp';
import { getW } from 'Lib/w/w';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import { speed } from 'Lib/speed/speed';
import 'Vendor/owlcarousel/owl.carousel.min';
import 'Lib/js-anchor-link/js-anchor-link';
import 'Bem/site/promo/promo';
import 'Bem/site/img-loader/img-loader';
import 'Bem/site/faq-accordion/faq-accordion';
import 'Bem/site/checkbox-accept/checkbox-accept';
import 'Bem/site/header-page/header-page';

svgSpriteLoader('/landing/b2b/svg/sprite.svg?v=20181026');

const $slider = $('.b2b__main-slider-owl');
const cSliderOn = 'owl-carousel';
const $linkSlider = $('.b2b__main-list-link');
const cLinkSlider = 'b2b__main-list-link_active';
const $mMenuLink = $('.b2b__m-menu-link');
const $sliderSupportBooks = $('.b2b__support-books-slider');

function moveMenuToHeader() {
    const $headerCont = $('.header__bottom').first();
    const $newHeaderCont = $('.cheader').first();
    const $newHeaderContForAfter = $('.cheader__container').last();
    const $menu = $('.b2b__menu').first();

    if (getW() > eksmoBP.smMax && $menu.length) {
        if ($headerCont.length) {
            if (!$headerCont.find($menu).length) {
                $headerCont.append($menu.remove());
            }
        } else if ($newHeaderCont.length && $newHeaderContForAfter.length) {
            if (!$newHeaderCont.find($menu).length) {
                $newHeaderContForAfter.after($menu.remove());
            }
        }
    }
}

if ($slider.length) {
    $slider.trigger('destroy.owl.carousel')
        .removeClass(cSliderOn)
        .addClass(cSliderOn)
        .owlCarousel({
            smartSpeed: speed * 2,
            dots: false,
            nav: true,
            navClass: ['b2b__main-slider-arrow-left', 'b2b__main-slider-arrow-right'],
            navText: ['', ''],
            items: 1,
            slideBy: 1,
            rewind: true,
            autoplay: true,
            autoplayTimeout: 3000,
        }).on('translated.owl.carousel', (event) => {
            $linkSlider.removeClass(cLinkSlider);
            $linkSlider.eq(event.item.index).addClass(cLinkSlider);
        });

    $linkSlider.on('click', function () {
        $slider.trigger('to.owl.carousel', [$(this).index()]);
        $linkSlider.removeClass(cLinkSlider);
        $(this).addClass(cLinkSlider);
    });
}

$mMenuLink.on('click', () => {
    $.fancybox.close();

    $.fancybox.open({
        type: 'inline',
        src: '.b2b__m-menu-modal',
        touch: false,
    });
});

if ($sliderSupportBooks.length) {
    $sliderSupportBooks.trigger('destroy.owl.carousel')
        .removeClass(cSliderOn)
        .addClass(cSliderOn)
        .owlCarousel({
            smartSpeed: speed * 2,
            dots: false,
            nav: true,
            navClass: ['b2b__support-books-slider-arrow-left arrow arrow_prev arrow_shadow', 'b2b__support-books-slider-arrow-right arrow arrow_next arrow_shadow'],
            navText: ['', ''],
            margin: 30,
            responsive: {
                0: { items: 1, slideBy: 1, margin: -20, nav: false },
                540: { items: 2, slideBy: 2, margin: -20, nav: false },
                770: { items: 3, slideBy: 3 },
                992: { items: 4, slideBy: 4 },
                1400: { items: 5, slideBy: 5 },
            },
        });
}

moveMenuToHeader();

$('body').on('eksmoResizeWidth', () => {
    moveMenuToHeader();
});